import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Virtual, FreeMode, Keyboard, Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Divider, Typography, Link, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import TravelRequest from '../../components/navbar/travelRequest';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import { alpha } from '@mui/system';

import { GlobalTheme } from '../../theme';
import DestinationStyle from './assets/scss/destination.module.scss';
const BASE_MEDIA_URL = 'https://aaryanholidays.in/express/uploads/';

const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
};

const SplCarousel = ({ discovery }) => {
    const [destinationData, setDestinationData] = useState([]);
    const videoRefs = useRef([]);
    const [swiperRef, setSwiperRef] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    const handleMouseEnter = (index) => {
        const videoElement = videoRefs.current[index];
        if (videoElement && videoElement.paused) {
            videoElement.play().catch(error => console.error('Error playing video:', error));
        }
    };

    const handleMouseLeave = (index) => {
        const videoElement = videoRefs.current[index];
        if (videoElement && videoElement.tagName === 'VIDEO' && !videoElement.paused) {
            videoElement.pause();
            videoElement.currentTime = 0;
        }
    };

    // const handleCardClick = (id, continent, country, tour) => {
    //     navigate(`/${continent}/${country}/${tour}/itenary/${id}`);
    // };
    const handlediscovCardClick = (id) => {
        navigate(`/search/${id}`);
    }
    useEffect(() => {
        const fetchData = async () => {
            try {


                const response = await fetch(`https://aaryanholidays.in/frontend/search-destinations?keywords=${encodeURIComponent(discovery)}`);
                // console.error(`https://aaryanholidays.in/frontend/search-destinations?keywords=${encodeURIComponent(discovery)}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                //setResults(data);
                setDestinationData(data);

                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return (

        <Box>
            {!isLoading && destinationData.length > 0 && (
                <>
                    <Grid id={`destinationContainer${Date.now()}`} item xs={12} lg={12} sx={{ px: { xs: 2.5, md: 0 }, }}>
                        <Stack direction={{ md: 'row' }} justifyContent='space-between' alignItems='center' display='flex' sx={{ mb: 4 }}>
                            <Typography id={`destinationHeading${Date.now()}`} component='h2' variant='h2' fontWeight={600}> {discovery} Packages </Typography>
                            {/* <Typography component='p' marginBottom={4}>Explore our customer favorites list of the top-selling destinations.</Typography> */}
                            <Button variant="text"
                                sx={{
                                    fontWeight: 400,
                                    overflow: 'hidden', // Ensures no overflow on hover
                                    display: 'flex',
                                    alignItems: 'center',
                                    transition: 'transform 0.3s ease',
                                    '&:hover .buttonContent': {
                                        transform: 'translateX(8px)', // Adjust as needed for animation distance
                                    },
                                    '&:hover .icon': {
                                        opacity: 1,
                                        transform: 'translateX(0)', // Slide icon in from the left
                                    },
                                }}
                            >
                                <Box
                                    className="buttonContent"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        transition: 'transform 0.3s ease',
                                    }}
                                >
                                    <Box component='span' onClick={() => handlediscovCardClick(discovery)} sx={{ mr: .5 }}>Explore ALl</Box>
                                    <KeyboardArrowRightOutlinedIcon
                                        className="icon"
                                        sx={{
                                            ml: 1, // Add some spacing between text and icon
                                            opacity: 0, // Initially hidden
                                            transform: 'translateX(-10px)', // Initial position off to the left
                                            transition: 'opacity 0.3s ease, transform 0.3s ease', // Smooth transition for appearance
                                        }}
                                    />
                                </Box>
                            </Button>
                        </Stack>

                        <Swiper
                            keyboard={{ enabled: true }}
                            id={`${discovery.toLowerCase().replace(/\s+/g, '')}${Date.now()}`}
                            onSwiper={setSwiperRef}
                            // slidesPerView={3}

                            centeredSlides={false}
                            spaceBetween={50}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={{
                                nextEl: '.custom-swiper-button-next',
                                prevEl: '.custom-swiper-button-prev',
                            }}
                            grabCursor={true}
                            // freeMode={true}

                            // slidesOffsetAfter={180}
                            // autoplay={{
                            //     delay: 1500,
                            //     disableOnInteraction: true,
                            // }}
                            loop={true}

                            modules={[Virtual, FreeMode, Keyboard, Pagination, Autoplay, Navigation]}

                            className={DestinationStyle.swiperContainer}
                            breakpoints={{
                                0: { slidesPerView: 1, spaceBetween: 10 },
                                600: { slidesPerView: 2, spaceBetween: 20 },
                                900: { slidesPerView: 3, spaceBetween: 40 },
                                // 1200: { slidesPerView: 3, spaceBetween: 90 },
                            }}
                            style={{
                                width: '100%',
                                position: 'relative',
                                paddingBottom: 50,

                                '& .swiper-pagination': {
                                    position: 'relative',
                                }
                            }}
                        >
                            {[...destinationData]
                                .sort((a, b) => b.id - a.id) // Sort by id descending
                                .slice(0, 5).map((tour, index) => (
                                    <SwiperSlide
                                        id='destinationSlide'
                                        key={index}
                                        virtualIndex={index}
                                        className={DestinationStyle.swiperSlideCustom}

                                    >
                                        <Card
                                            key={index}
                                            sx={{
                                                position: 'relative',
                                                borderRadius: 2,
                                                width: { xs: '100%', sm: 367 },
                                                height: {
                                                    xs: 468,
                                                    sm: 500
                                                },
                                                objectFit: 'cover',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <Box
                                                id={'destination' + tour.id}
                                                onMouseEnter={() => handleMouseEnter(index)}
                                                onMouseLeave={() => handleMouseLeave(index)}
                                                sx={{ height: 'inherit' }}
                                            >
                                                {tour.type === 'video' ? (
                                                    <CardMedia
                                                        id={`destinationThumbsVid${index}`}
                                                        component="video"
                                                        src={`${BASE_MEDIA_URL}${tour.src}`}
                                                        loop
                                                        autoPlay
                                                        muted
                                                        playsInline
                                                        height='ínherit'
                                                        ref={(el) => (videoRefs.current[index] = el)}
                                                        sx={{
                                                            objectFit: 'cover'
                                                        }}
                                                    >
                                                        <source src={`${BASE_MEDIA_URL}${tour.src}`} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </CardMedia>
                                                ) : (
                                                    <CardMedia
                                                        id={`destinationThumbsImg${index}`}
                                                        component="img"
                                                        src={`${BASE_MEDIA_URL}${tour.src}`}
                                                        alt={tour.alt}
                                                        loading='lazy'
                                                        height='100%'
                                                    />
                                                )}
                                                <CardContent id={'specialFeatureContent' + tour.id}
                                                    sx={{
                                                        position: 'absolute',
                                                        width: '100%',
                                                        height: '100%',
                                                        top: 0,
                                                        left: 0,
                                                        px: 0, py: 0
                                                    }}
                                                >
                                                    <Box sx={{
                                                        position: 'relative',
                                                        bottom: 0,
                                                        left: 0,
                                                        px: 2,
                                                        textAlign: 'left',
                                                        height: 'inherit',
                                                        // width: '100%',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        flexWrap: 'wrap',
                                                        justifyContent: 'flex-end',

                                                        background: `linear-gradient(0deg, ${alpha(GlobalTheme.palette.common.tertiary, .7)} 30%, ${alpha(GlobalTheme.palette.common.tertiary, 0)} 70%)`,
                                                        transition: 'all .4s ease',
                                                        // "&:hover": {
                                                        //     pt: 23,
                                                        //     background: `linear-gradient(0deg, ${alpha(GlobalTheme.palette.common.tertiary, .8)} 10%, ${alpha(GlobalTheme.palette.common.tertiary, 0)} 100%)`,
                                                        // }
                                                    }}>
                                                        <Typography component='p' variant="subtitle2" fontWeight={400} color='warning.light' gutterBottom>
                                                            {tour.tour_days}
                                                        </Typography>

                                                        <Typography component='p' variant="subtitle2" color='common.white' sx={{ textAlign: 'left' }} fontWeight={400}>
                                                            {truncateText(tour.thumbnail_desc, 90)}
                                                        </Typography>
                                                        <Typography variant='h3' component='h3' sx={{ color: GlobalTheme.palette.common.white, pr: 4 }} gutterBottom>
                                                            <span dangerouslySetInnerHTML={{ __html: tour.thumbnail_heading }} />
                                                        </Typography>
                                                        <Divider sx={{ backgroundColor: GlobalTheme.palette.common.white, mb: .5 }} />

                                                        <Typography component='p' variant="subtitle1" color='common.white' sx={{ textAlign: 'left' }} >
                                                            INR {tour.price} <Typography component='span' fontWeight={400} variant='subtitle2'>per person</Typography>
                                                        </Typography>

                                                        <Stack direction='row' justifyContent='space-between' sx={{ my: 2 }} spacing={3}>
                                                            <Link id={'btn' + discovery.replace(/\s+/g, '') + tour.id}
                                                                href={`/${tour.continent_name.replace(/\s+/g, '-')}/${tour.tour_type_name.replace(/\s+/g, '-')}/${tour.thumbnail_heading.replace(/\s+/g, '-')}/itenary/${tour.id}`}
                                                                className={DestinationStyle.viewTourBtn}
                                                                variant="contained"
                                                                underline='none'
                                                                // onClick={() => handleCardClick(tour.id, tour.continent_name.replace(/\s+/g, '-'), tour.tour_type_name.replace(/\s+/g, '-'), tour.thumbnail_heading.replace(/\s+/g, '-'))}
                                                                sx={{
                                                                    px: 2, py: 1.5, borderRadius: 2,
                                                                    color: GlobalTheme.palette.common.white,
                                                                    borderColor: GlobalTheme.palette.primary.main,
                                                                    backgroundColor: GlobalTheme.palette.primary.main,

                                                                    '&:hover, &:focus': {
                                                                        color: GlobalTheme.palette.common.black,
                                                                        borderColor: GlobalTheme.palette.common.white,
                                                                        backgroundColor: GlobalTheme.palette.common.white,
                                                                    }
                                                                }}>
                                                                View Tour
                                                            </Link>

                                                            <TravelRequest
                                                                id={`getQutBtn${tour.thumbnail_heading.substring(0, 2).replace(/\s+/g, '')}_${tour.id}_${Date.now()}`}
                                                                variant="outlined"
                                                                size='medium'
                                                                btnLabel='Get a Quote'
                                                                sxOverrides={{
                                                                    py: .625, px: 1.875, borderRadius: 2,
                                                                    color: GlobalTheme.palette.common.white,
                                                                    borderColor: GlobalTheme.palette.common.white,
                                                                    backgroundColor: 'transparent',

                                                                    '&:hover': {
                                                                        color: GlobalTheme.palette.primary.main,
                                                                        backgroundColor: GlobalTheme.palette.common.white,
                                                                    }

                                                                }}
                                                                selectedDestination={tour.thumbnail_heading}
                                                            />
                                                        </Stack>
                                                    </Box>
                                                </CardContent>
                                            </Box>
                                        </Card>
                                    </SwiperSlide>
                                ))}

                            {destinationData.length > 3 && (
                                <>
                                    <IconButton
                                        className="custom-swiper-button-prev"
                                        sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: 10,
                                            transform: 'translateY(-60px)',
                                            zIndex: 10,
                                            color: GlobalTheme.palette.primary.main,
                                            backgroundColor: alpha(GlobalTheme.palette.common.white, .8),
                                            transition: 'transform .3s ease-in',

                                            "&:hover, &:focus-within": {
                                                boxShadow: GlobalTheme.shadows[5],
                                                backgroundColor: GlobalTheme.palette.common.white,
                                                "& .MuiSvgIcon-root": {
                                                    transform: 'translateX(-4px)',
                                                    transition: 'transform 0.3s ease',
                                                },
                                            }
                                        }}
                                        aria-label={`{discovery} Packages Previous`}
                                    >
                                        <KeyboardArrowLeftOutlinedIcon sx={{ fontSize: GlobalTheme.typography.h1.fontSize }} />
                                    </IconButton>

                                    <IconButton
                                        className="custom-swiper-button-next"
                                        sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: 30,
                                            transform: 'translateY(-60px)',
                                            zIndex: 10,
                                            color: GlobalTheme.palette.primary.main,
                                            backgroundColor: alpha(GlobalTheme.palette.common.white, .8),
                                            transition: 'transform .3s ease-in',

                                            "&:hover, &:focus-visible": {
                                                boxShadow: GlobalTheme.shadows[5],
                                                backgroundColor: GlobalTheme.palette.common.white,

                                                "& .MuiSvgIcon-root": {
                                                    transform: 'translateX(4px)',
                                                    transition: 'transform 0.3s ease',
                                                },
                                            }
                                        }}
                                        aria-label={`{discovery} Packages Next`}
                                    >
                                        <KeyboardArrowRightOutlinedIcon sx={{ fontSize: GlobalTheme.typography.h1.fontSize }} />
                                    </IconButton>
                                </>
                            )}
                        </Swiper>
                    </Grid>
                    <Divider sx={{ mt: 3 }} />
                </>
            )}
        </Box >
    );
};

export default SplCarousel;
